import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExgSelectComponent} from 'exc-controls-v2';

@Component({
  selector: 'app-tab-settings-schedule-template',
  templateUrl: './tab-settings-schedule-template.component.html',
  styles: []
})
export class TabSettingsScheduleTemplateComponent extends ExcTranslation implements IExgTab, OnInit {

  Data: any;
  tabinstance: any;
  value: any;
  selectedTypeIdent: any;

  @ViewChild('typSelector') typSelector!: ExgSelectComponent

  constructor(public enmSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
  }


  changeType($event: any) {
    this.selectedTypeIdent = this.typSelector.list[$event].enmIdent;
  }
}
